// src/zoom-in.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var ZoomInIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.1691 15.8796L20.7823 20.5134C21.0725 20.8049 21.0725 21.2874 20.7823 21.5789C20.6322 21.7296 20.4421 21.8 20.252 21.8C20.0618 21.8 19.8717 21.7296 19.7216 21.5789L15.0083 16.8446C15.0033 16.8395 14.9983 16.832 14.9933 16.8245C14.9883 16.8169 14.9833 16.8094 14.9783 16.8044C13.7775 17.5683 12.3565 18.0206 10.8254 18.0206C6.51244 18.0206 3 14.4925 3 10.1603C3 5.82808 6.51244 2.29999 10.8254 2.29999C15.1384 2.29999 18.6509 5.82808 18.6509 10.1603C18.6509 12.4118 17.6902 14.4423 16.1691 15.8796ZM10.8154 3.80772C7.323 3.80772 4.49104 6.65231 4.49104 10.1603C4.49104 13.6683 7.323 16.5129 10.8154 16.5129C14.3079 16.5129 17.1398 13.6683 17.1398 10.1603C17.1398 6.65231 14.3079 3.80772 10.8154 3.80772ZM11.5659 9.40644H13.8174C14.2277 9.40644 14.568 9.74819 14.568 10.1603C14.568 10.5724 14.2277 10.9142 13.8174 10.9142H11.5659V13.1758C11.5659 13.5879 11.2256 13.9296 10.8153 13.9296C10.4051 13.9296 10.0648 13.5879 10.0648 13.1758V10.9142H7.81327C7.40298 10.9142 7.06274 10.5724 7.06274 10.1603C7.06274 9.74819 7.40298 9.40644 7.81327 9.40644H10.0648V7.14484C10.0648 6.73273 10.4051 6.39097 10.8153 6.39097C11.2256 6.39097 11.5659 6.73273 11.5659 7.14484V9.40644Z",
      clipRule: "evenodd"
    }
  ),
  "ZoomInIcon"
);

export {
  ZoomInIcon
};
